<template lang="html">
	<div class="component animatorproperties">
		<div class="script-name">
			<div style="padding: 4px;display: inline-block;"><i class="icon-directions_run"></i> <span>Animator</span></div>
		</div>
		<div class="script-properties">
			<select v-model="modelValue.asset" @change="change()">
				<option :value="null">No image</option>
				<option v-for="asset in assets" :key="asset.name">{{asset.name}}</option>
			</select>
			<select v-model="modelValue.spritesheet" style="margin-top: 6px;" @change="change()">
				<option :value="null">No spritesheet</option>
				<option v-for="spritesheet in spritesheets" :key="spritesheet.id" :value="spritesheet.id">{{spritesheet.name}}</option>
			</select>
			<select v-model="modelValue.defaultAnimation" style="margin-top: 6px;" @change="change()" v-if="modelValue.spritesheet">
				<option :value="null">No default animation</option>
				<option v-for="(animation, name) in animations" :key="name">{{name}}</option>
			</select>
			<div style="font-size: 14px;padding: 8px 0;" v-if="modelValue.spritesheet">
				<label>Sprite Offset</label>
				<div style="display: flex;">
					<div v-for="(label, variable) in {x: 'X', y: 'Y'}" :key="variable" class="input-group" style="margin-right: 7px;">
						<input type="text" v-model="modelValue.offset[variable]" @input="modelValue.offset[variable] = parseInt($event.target.value.replace(/[^0-9.]/g, '') || 0);change()">
						<span class="input-group-append">{{label}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['modelValue', 'assets', 'spritesheets'],
	emits: ['update:modelValue'],
	computed: {
		animations: function () {
			try {
				return this.spritesheets.find(spritesheet => spritesheet.id === this.modelValue.spritesheet).data.animations;
			} catch (e) {
				return null;
			}
		}
	},
	methods: {
		change: function () {
			if (this.modelValue.spritesheet === null) {
				this.modelValue.defaultAnimation = null;
			} else {
				this.modelValue.offset = this.modelValue.offset || {x: 0, y: 0};
			}
			this.$emit('update:modelValue', this.modelValue);
		}
	}
}
</script>
